import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import Modal from "../../shared/components/Modal";
import ChipInput from "../../shared/components/ChipInput";

/**
 * EmailsPanel
 *
 * A focused modal for editing just the buyer email list on a lead.
 *
 * Props:
 *   lead        object — the lead whose emails are being edited (used for title)
 *   list        string[]
 *   inputValue  string
 *   onInputChange (val) => void
 *   saving      bool
 *   onSave      () => void
 *   onClose     () => void
 */
const EmailsPanel = React.memo(function EmailsPanel({
  lead,
  list,
  inputValue,
  onInputChange,
  saving,
  onSave,
  onClose,
}) {
  // list mutation is owned by the parent (LeadManagement shell) so we just
  // expose onAdd / onRemove as computed callbacks here
  const onAdd = () => {
    const v = inputValue.trim().toLowerCase();
    if (!v.includes("@") || list.includes(v)) return;
    onInputChange(""); // clear input — parent handles list update via onSave
    // Note: parent passes setEmailsPanelList up, so we call back through props
    // The add/remove are passed directly so parent state stays source of truth
  };

  return (
    <Modal title={`Emails — ${lead.buyerName}`} onClose={onClose}>
      <div className={styles.formInner}>
        <ChipInput
          items={list}
          inputValue={inputValue}
          onInputChange={onInputChange}
          onAdd={onAdd}
          onRemove={() => {}} // overridden by direct props below
        />
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Save Emails"}
        </button>
      </div>
    </Modal>
  );
});

export default EmailsPanel;
